<template lang="pug">
  .app-container
    ErrorBox(ref="errorBox")
    router-view(v-if="!serverDown" @error="onError")
    ServerDown(v-else @serverUp="serverDown = false")
</template>

<script>
import miniToastr from 'mini-toastr'
import ServerDown from '@/components/pages/ServerDown'
import ErrorBox from './ErrorBox'

export default {
  name: 'app',
  data: () => ({
    serverDown: false
  }),
  methods: {
    onError(e) {
      if (e.data && typeof e.data === 'string') { // 502 response from server is returned as html string
        this.serverDown = true
        return
      }

      if (!e.response) {
        console.error(e) // eslint-disable-line
        return
      }

      switch (e.response.data.status) {
        case 500:
          this.$refs.errorBox.show(e)
          break
        case 502:
        case 503:
        case 504:
          this.serverDown = true
          break
        default:
          miniToastr.error(e.response.data.message, e.response.status, 30000)
      }
    }
  },
  watch: {
    $route() {
      document.querySelectorAll('.mini-toastr__notification.-error')
        .forEach((element) => {
          miniToastr.config.animation(element)
        })
    }
  },
  components: {
    ServerDown,
    ErrorBox
  }
}
</script>

<style lang="scss">
.app-container {
  text-align: left;
  height: 100%;
}

.ssp-form-horizontal {
  .form-group {
    display: flex;
    .ic-label {
      flex: 1;
      padding: 5px;
    }
    .ic-control {
      width: 75%;
      input[type="checkbox"] {
        width: 25px;
        height: 25px;
      }
    }
  }
}

#mini-toastr {
  position: absolute;
  z-index: 1000;
  top: 70px;
  left: 20px;
  max-width: 0;
}

.mini-toastr__notification, .mini-toastr__notification:hover {
    box-shadow: none !important;
}

.mini-toastr__notification.-success {
    background-color: #06c54e !important;
}

.mini-toastr__notification.-info {
    background-color: #004fe1 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue